import { render, staticRenderFns } from "./ownerDetail.vue?vue&type=template&id=71b2a22f&scoped=true&"
import script from "./ownerDetail.vue?vue&type=script&lang=js&"
export * from "./ownerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ownerDetail.vue?vue&type=style&index=0&id=71b2a22f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2a22f",
  null
  
)

export default component.exports